import { useEffect } from 'react';

/**
 * Mobil scroll kilidi: icerik viewport'a sigiyorsa tek parmak kaydirmayi engeller.
 * Cift parmak her zaman serbest — kullanici iki parmakla scroll yapabilir.
 * Icerik viewport'tan tasarsa (orn. multi chat) tek parmak da serbest.
 */
export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;
    const html = document.documentElement;
    html.style.overscrollBehavior = 'none';
    document.body.style.overscrollBehavior = 'none';

    const preventBounce = (e: TouchEvent) => {
      if (e.touches.length >= 2) return;
      // Sadece masaustu veya kucuk mobilde bounce engelle; tablette serbest birak
      const w = window.innerWidth;
      if (w >= 520 && w < 900) return;
      if (html.scrollHeight <= html.clientHeight) {
        e.preventDefault();
      }
    };
    document.addEventListener('touchmove', preventBounce, { passive: false });
    return () => {
      html.style.overscrollBehavior = '';
      document.body.style.overscrollBehavior = '';
      document.removeEventListener('touchmove', preventBounce);
    };
  }, [active]);
}
